<template>
  <b-card no-body class="flex-container ">
    <div slot="header">
      <window-header :cmp-title="'Stats for '+project.name" widget-name="project_stats"></window-header>
    </div>
    <div class="window-body">
      <b-table v-if="items.length"  striped hover :items="items" :fields="fields"></b-table>
      <loading-overlay :show="loading"></loading-overlay>
    </div>
    <window-footer></window-footer>
  </b-card>
</template>

<script>
  import WindowHeader from '../common/WindowHeader'
  import WindowFooter from '../common/WindowFooter'
  import LoadingOverlay from '../LoadingOverlay'
  export default {
    name: 'workpack-stats',
    components: {LoadingOverlay, WindowHeader, WindowFooter},
    data () {
      return {
        items: [],
        fields: ['stat', 'result'],
        loading: false
      }
    },
    computed: {
      project() {
        return this.$store.getters['project/currentProject']
      },
    },
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true
        this.$http.get('/api/projects/stats', {
          params: {
            workpack_id: this.project.workpack.id
          }
        })
          .then(res => {
            this.items = res.body
            this.loading = false
          }, res => {
            console.error(res)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/projects/Stats.vue